
import { Component, Vue } from 'vue-property-decorator'
import { OrderRecordBySchoolDto} from '@/api/service-proxies'
import moment from 'moment';

@Component
export default class DetailDialog extends Vue {
  private dialogVisible: boolean = false

  isSkipHolidays:boolean = false
  isExporting:boolean=false
  orderRecordBySchoolDto = new OrderRecordBySchoolDto()
  value: any = "";
  lateTimes:any="";

  public open(row) {
    this.orderRecordBySchoolDto = row;
    this.dialogVisible = true
  }
  close(){
    this.dialogVisible = false;
  }

 
}

